import React, { useEffect, useState } from "react";
import { adminOperators } from "../../lib/api";

export default function AdminOperators() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); adminOperators(q).then((r) => { setRows(r); setLoading(false); }).catch(() => setLoading(false)); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  return (
    <div>
      <h1 className="adm-h1">Operators</h1>
      <p className="adm-sub">{rows.length} DGCA non-scheduled operators and their fleets. Private — never exposed on the public site.</p>
      <div className="adm-tools">
        <input placeholder="Search operator, city or aircraft code" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
        <button className="adm-btn" type="button" onClick={load}>Search</button>
      </div>
      <div className="panel" style={{ padding: 6 }}>
        <table className="tbl">
          <thead><tr><th>Operator</th><th>City</th><th>Fleet</th><th>AOP</th><th>Valid till</th></tr></thead>
          <tbody>
            {rows.map((o) => (
              <tr key={o.id} onClick={() => setOpen(open === o.id ? null : o.id)}>
                <td style={{ fontWeight: 700 }}>{o.name}
                  {open === o.id ? (
                    <div style={{ marginTop: 8, fontWeight: 400 }}>
                      <div style={{ color: "var(--muted)", fontSize: 13 }}>{o.address}</div>
                      <div style={{ fontSize: 13, marginTop: 4 }}>{o.phone} {o.emails?.length ? "· " + o.emails.join(", ") : ""}</div>
                      <div style={{ marginTop: 8 }}>{(o.fleet || []).map((fl, i) => (<span key={i} className="pill Quoted" style={{ marginRight: 6, marginBottom: 6, display: "inline-block" }}>{fl.m || fl.f} · {fl.r} · {fl.s} seats</span>))}</div>
                    </div>
                  ) : null}
                </td>
                <td>{o.city}</td>
                <td>{(o.fleet || []).length}</td>
                <td>{o.aop}</td>
                <td>{o.valid}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading ? <p className="adm-sub" style={{ padding: 16 }}>Loading…</p> : null}
      </div>
    </div>
  );
}
